import stringFormatService from '../../services/stringFormatService';
import {config} from '../config';
import configGettersService from './configGettersService';

const getAnniversaryLearnMoreUrl = () =>
    configGettersService.getLocalizedPropertyOrDefault(config.data.anniversary.learnMoreUrl);

export default {
    getAnniversaryLogoSrc: () => config.data.anniversary.logoSrc,
    getAnniversaryThumbnailSrc: () => config.data.anniversary.thumbnailSrc,
    getAnniversaryVideoSrc: () => config.data.anniversary.videoSrc,
    getAnniversaryImageSrc: () => config.data.anniversary.imageSrc,
    getIsAnniversaryEnabled: () => config.data.anniversary.isEnabled,
    getAnniversaryLearnMoreUrlFormatted: () =>
        stringFormatService.getLanguageFormattedString(getAnniversaryLearnMoreUrl()),
};
